export var firstLevelNavList = [
    {
        name: 'Study Abroad',
        uniqueId: 'countries',
        type: 'modal',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/earth_icon_Kvo-hR5QA.svg'
    },
    {
        name: 'Exams',
        uniqueId: 'exams',
        type: 'modal',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/file_validation_icon_R6S_UIDVT1.svg'
    },
    {
        name: 'Resources',
        uniqueId: 'resources',
        type: 'modal',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_SlaW0XlAq8.svg'
    },
    {
        name: 'Blogs',
        uniqueId: 'blogs',
        type: 'link',
        link: '/blog/',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/license_icon_G1BdqCUonK.svg'
    },
    {
        name: 'Leap Digest',
        uniqueId: 'leap_digest',
        type: 'link',
        link: '/digest',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/newspaper_icon_4ZuR_rpoky.svg'
    },
    {
        name: 'Events',
        uniqueId: 'events',
        type: 'link',
        link: '/events',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/calendar_icon_FAVAl9rYlm.svg'
    },
    {
        name: 'About Us',
        uniqueId: 'about_us',
        type: 'link',
        link: '/about-us',
        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/information_icon_6pQIrJ35LR.svg'
    }
];
export var countryNavData = {
    usa: {
        uniqueId: 'usa',
        tabName: 'USA',
        topHeading: 'Study in USA',
        topHeadingLink: '/usa',
        subNavs: [
            {
                heading: 'Top Cities in USA',
                navLinks: [
                    {
                        name: 'Universities in Oxford',
                        link: '/usa/universities-colleges-list/oxford-ohio-ohio-in-usa'
                    },
                    {
                        name: 'Universities in Cambridge',
                        link: '/usa/universities-colleges-list/cambridge-massachusetts-massachusetts-in-usa'
                    },
                    {
                        name: 'Universities in Columbia',
                        link: '/usa/universities-colleges-list/columbia-south-carolina-south-carolina-in-usa'
                    },
                    {
                        name: 'Universities in Boston',
                        link: '/usa/universities-colleges-list/boston-massachusetts-in-usa'
                    },
                    {
                        name: 'Universities in Princeton',
                        link: '/usa/universities-colleges-list/princeton-new-jersey-in-usa'
                    }
                ]
            },
            {
                heading: 'Top Courses in USA',
                navLinks: [
                    {
                        name: 'Masters in USA',
                        link: '/usa/universities-colleges-list/masters-in-usa'
                    },
                    {
                        name: 'Masters in computer science in USA',
                        link: '/usa/universities-colleges-list/masters-in-computer-science-in-usa'
                    },
                    {
                        name: 'Masters in data science in USA',
                        link: '/usa/universities-colleges-list/masters-in-data-science-in-usa'
                    }
                ]
            },
            {
                heading: 'Top Universities in USA',
                navLinks: [
                    {
                        name: 'Harvard University',
                        link: '/usa/university-details/harvard-university'
                    },
                    {
                        name: 'Stanford University',
                        link: '/usa/university-details/stanford-university'
                    },
                    {
                        name: 'Northeastern University',
                        link: '/usa/university-details/northeastern-university'
                    },
                    {
                        name: 'Columbia University',
                        link: '/usa/university-details/columbia-university'
                    },
                    {
                        name: 'Yale University',
                        link: '/usa/university-details/yale-university'
                    }
                ]
            }
        ]
    },
    uk: {
        uniqueId: 'uk',
        tabName: 'UK',
        topHeading: 'Study in UK',
        topHeadingLink: '/uk',
        subNavs: [
            {
                heading: 'Top Cities in UK',
                navLinks: [
                    {
                        name: 'Universities in Bangor',
                        link: '/uk/universities-colleges-list/bangor-uk-in-uk'
                    },
                    {
                        name: 'Universities in Oxford',
                        link: '/uk/universities-colleges-list/oxford-mississippi-in-uk'
                    },
                    {
                        name: 'Universities in Cambridge',
                        link: '/uk/universities-colleges-list/cambridge-massachusetts-in-uk'
                    },
                    {
                        name: 'Universities in Coventry',
                        link: '/uk/universities-colleges-list/coventry-in-uk'
                    },
                    {
                        name: 'Universities in Edinburgh',
                        link: '/uk/universities-colleges-list/edinburgh-in-uk'
                    }
                ]
            },
            {
                heading: 'Top Courses in UK',
                navLinks: [
                    {
                        name: 'Masters in UK',
                        link: '/uk/universities-colleges-list/masters-in-uk'
                    },
                    {
                        name: 'Masters in Computer Science in UK',
                        link: '/uk/universities-colleges-list/masters-in-computer-science-in-uk'
                    },
                    {
                        name: 'Masters in Physiotherapy in UK',
                        link: '/uk/universities-colleges-list/masters-in-physiotherapy-in-uk'
                    }
                ]
            },
            {
                heading: 'Top Universities in UK',
                navLinks: [
                    {
                        name: 'University of Oxford',
                        link: '/uk/university-details/university-of-oxford'
                    },
                    {
                        name: 'University of Cambridge',
                        link: '/uk/university-details/university-of-cambridge'
                    },
                    {
                        name: 'Coventry University',
                        link: '/uk/university-details/coventry-university'
                    },
                    {
                        name: 'University of Leeds',
                        link: '/uk/university-details/university-of-leeds'
                    },
                    {
                        name: 'University of East London',
                        link: '/uk/university-details/university-of-east-london'
                    }
                ]
            }
        ]
    },
    canada: {
        uniqueId: 'canada',
        tabName: 'Canada',
        topHeading: 'Study in Canada',
        topHeadingLink: '/canada',
        subNavs: [
            {
                heading: 'Top Cities in Canada',
                navLinks: [
                    {
                        name: 'Universities in Toronto',
                        link: '/canada/universities-colleges-list/toronto-ontario-in-canada'
                    },
                    {
                        name: 'Universities in Canada',
                        link: '/canada/universities-colleges-list'
                    },
                    {
                        name: 'Universities in Alberta',
                        link: '/canada/universities-colleges-list/edmonton-alberta-in-canada'
                    },
                    {
                        name: 'Universities in Kingston',
                        link: '/canada/universities-colleges-list/kingston-in-canada'
                    },
                    {
                        name: 'Universities in London',
                        link: '/canada/universities-colleges-list/london-canada-in-canada'
                    }
                ]
            },
            {
                heading: 'Top Courses in Canada',
                navLinks: [
                    {
                        name: 'Masters in Canada',
                        link: '/canada/universities-colleges-list/masters-in-canada'
                    },
                    {
                        name: 'PhD in Canada',
                        link: '/canada/universities-colleges-list/phd-in-canada'
                    },
                    {
                        name: 'Masters in Computer Science in Canada',
                        link: '/canada/universities-colleges-list/masters-in-computer-science-in-canada'
                    }
                ]
            },
            {
                heading: 'Top Universities in UK',
                navLinks: [
                    {
                        name: 'Conestoga College',
                        link: '/canada/university-details/conestoga-college'
                    },
                    {
                        name: 'University of Toronto',
                        link: '/canada/university-details/university-of-toronto'
                    },
                    {
                        name: 'Lambton College',
                        link: '/canada/university-details/lambton-college'
                    },
                    {
                        name: 'Humber College',
                        link: '/canada/university-details/humber-college-north'
                    },
                    {
                        name: 'Centennial College',
                        link: '/canada/university-details/centennial-college'
                    }
                ]
            }
        ]
    },
    ireland: {
        uniqueId: 'ireland',
        tabName: 'Ireland',
        topHeading: 'Study in Ireland',
        topHeadingLink: '/ireland',
        subNavs: [
            {
                heading: 'Top Cities in Ireland',
                navLinks: [
                    {
                        name: 'Universities in Dublin',
                        link: '/ireland/universities-colleges-list/dublin-leinster-in-ireland'
                    },
                    {
                        name: 'Universities in Galway',
                        link: '/ireland/universities-colleges-list/galway-connaught-in-ireland'
                    },
                    {
                        name: 'Universities in Waterford',
                        link: '/ireland/universities-colleges-list/waterford-ulster-in-ireland'
                    },
                    {
                        name: 'Universities in Limerick',
                        link: '/ireland/universities-colleges-list/limerick-in-ireland'
                    },
                    {
                        name: 'Universities in Cork',
                        link: '/ireland/universities-colleges-list/cork-ulster-in-ireland'
                    }
                ]
            },
            {
                heading: 'Top Courses in Ireland',
                navLinks: [
                    {
                        name: 'Masters in Ireland',
                        link: '/ireland/universities-colleges-list/masters-in-ireland'
                    },
                    {
                        name: 'PhD in Ireland',
                        link: '/ireland/universities-colleges-list/phd-in-ireland'
                    },
                    {
                        name: 'Masters in Data Science in Ireland',
                        link: '/ireland/universities-colleges-list/masters-in-data-science-in-ireland'
                    }
                ]
            },
            {
                heading: 'Top Universities in Ireland',
                navLinks: [
                    {
                        name: 'Trinity College',
                        link: '/ireland/university-details/trinity-college-dublin-the-university-of-dublin'
                    },
                    {
                        name: 'Institute of Technology - Carlow',
                        link: '/ireland/university-details/institute-of-technology-carlow'
                    },
                    {
                        name: 'Dublin City University',
                        link: '/ireland/university-details/dublin-city-university'
                    },
                    {
                        name: 'University College Dublin',
                        link: '/ireland/university-details/university-college-dublin'
                    },
                    {
                        name: 'University of Limerick',
                        link: '/ireland/university-details/university-of-limerick'
                    }
                ]
            }
        ]
    },
    australia: {
        uniqueId: 'australia',
        tabName: 'Australia',
        topHeading: 'Study in Australia',
        topHeadingLink: '/australia',
        subNavs: [
            {
                heading: 'Top Cities in Australia',
                navLinks: [
                    {
                        name: 'Universities in Melbourne',
                        link: '/australia/universities-colleges-list/melbourne-aus-victoria-in-australia'
                    },
                    {
                        name: 'Universities in Wollongong',
                        link: '/australia/universities-colleges-list/wollongong-new-south-wales-aus-in-australia'
                    },
                    {
                        name: 'Universities in Canberra',
                        link: '/australia/universities-colleges-list/canberra-australian-capital-territory-in-australia'
                    },
                    {
                        name: 'Universities in Adelaide',
                        link: '/australia/universities-colleges-list/adelaide-south-australia-in-australia'
                    }
                ]
            },
            {
                heading: 'Top Courses in Australia',
                navLinks: [
                    {
                        name: 'Masters in Australia',
                        link: '/australia/universities-colleges-list/masters-in-australia'
                    },
                    {
                        name: 'Masters in Business Analytics in Australia',
                        link: '/australia/universities-colleges-list/masters-in-business-analytics-in-australia'
                    },
                    {
                        name: 'Masters in Public Health in Australia',
                        link: '/australia/universities-colleges-list/masters-in-public-health-in-australia'
                    }
                ]
            },
            {
                heading: 'Top Universities in Australia',
                navLinks: [
                    {
                        name: 'Deakin University',
                        link: '/australia/university-details/deakin-university'
                    },
                    {
                        name: 'Monash University',
                        link: '/australia/university-details/monash-university'
                    },
                    {
                        name: 'RMIT University',
                        link: '/australia/university-details/rmit-university'
                    },
                    {
                        name: 'Carnegie Mellon University',
                        link: '/australia/university-details/carnegie-mellon-university-australia'
                    },
                    {
                        name: 'The University of Queensland',
                        link: '/australia/university-details/university-of-queensland'
                    }
                ]
            }
        ]
    },
    germany: {
        uniqueId: 'germany',
        tabName: 'Germany',
        topHeading: 'Study in Germany',
        topHeadingLink: '/germany',
        subNavs: null
    },
    france: {
        uniqueId: 'france',
        tabName: 'France',
        topHeading: 'Study in France',
        topHeadingLink: '/france',
        subNavs: null
    },
    'new-zealand': {
        uniqueId: 'new-zealand',
        tabName: 'New Zealand',
        topHeading: 'Study in New Zealand',
        topHeadingLink: '/new-zealand',
        subNavs: null
    },
    italy: {
        uniqueId: 'italy',
        tabName: 'Italy',
        topHeading: 'Study in Italy',
        topHeadingLink: '/italy',
        subNavs: null
    }
};
export var examNavData = {
    ielts: {
        uniqueId: 'ielts',
        tabName: 'IELTS',
        topHeading: 'Free IELTS masterclass',
        topHeadingLink: '/exams/ielts/preparation-online',
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'IELTS Overview',
                        link: '/exams/ielts/'
                    },
                    {
                        name: 'IELTS Syllabus',
                        link: '/exams/ielts/syllabus-and-pattern'
                    },
                    {
                        name: 'IELTS Types',
                        link: '/exams/ielts/types'
                    },
                    {
                        name: 'IELTS Exam Fees',
                        link: '/exams/ielts/fees'
                    },
                    {
                        name: 'IELTS Eligibility',
                        link: '/exams/ielts/eligibility'
                    },
                    {
                        name: 'IELTS Dates',
                        link: '/exams/ielts/dates'
                    },
                    {
                        name: 'IELTS Registration',
                        link: '/exams/ielts/registration'
                    },
                    {
                        name: 'IELTS Coaching Centres',
                        link: '/exams/ielts/centre'
                    },
                    {
                        name: 'IELTS Results',
                        link: '/exams/ielts/results'
                    },
                    {
                        name: 'IELTS Slot Booking',
                        link: '/exams/ielts/slot-booking'
                    }
                ]
            },
            {
                heading: 'Practice',
                navLinks: [
                    {
                        name: 'Test',
                        link: '/exams/ielts/practice-test',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg'
                    },
                    {
                        name: 'Speaking',
                        link: '/exams/ielts/practice-test/speaking',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/chat_icon_QlTt4yG6WW.svg'
                    },
                    {
                        name: 'Writing',
                        link: '/exams/ielts/practice-test/writing',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg'
                    },
                    {
                        name: 'Reading',
                        link: '/exams/ielts/practice-test/reading',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg'
                    },
                    {
                        name: 'Listening',
                        link: '/exams/ielts/practice-test/listening',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg'
                    }
                ]
            }
        ]
    },
    duolingo: {
        uniqueId: 'duolingo',
        tabName: 'Duolingo',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam Details',
                navLinks: [
                    {
                        name: 'Duolingo Overview',
                        link: '/exams/duolingo'
                    },
                    {
                        name: 'Duolingo Syllabus',
                        link: '/exams/duolingo/pattern-and-syllabus'
                    },
                    {
                        name: 'Duolingo Exam Fees',
                        link: '/exams/duolingo/fees'
                    },
                    {
                        name: 'Duolingo Preparation',
                        link: '/exams/duolingo/how-to-prepare-for-duolingo-english-test'
                    },
                    {
                        name: 'Duolingo Sample Questions',
                        link: '/exams/duolingo/sample-questions-and-answers'
                    }
                ]
            },
            {
                heading: 'Duolingo Accepted Countries',
                navLinks: [
                    {
                        name: 'Australia',
                        link: '/blog/duolingo-accepted-universities-in-australia/'
                    },
                    {
                        name: 'Canada',
                        link: '/blog/duolingo-accepted-universities-in-canada/'
                    },
                    {
                        name: 'Germany',
                        link: '/blog/duolingo-accepted-universities-in-germany/'
                    },
                    {
                        name: 'Ireland',
                        link: '/blog/duolingo-accepted-universities-in-ireland/'
                    },
                    {
                        name: 'UK',
                        link: '/blog/duolingo-accepted-universities-in-uk/'
                    }
                ]
            }
        ]
    },
    sat: {
        uniqueId: 'sat',
        tabName: 'SAT',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'SAT Overview',
                        link: '/exams/sat'
                    },
                    {
                        name: 'SAT Syllabus',
                        link: '/exams/sat/syllabus'
                    },
                    {
                        name: 'SAT Exam Fees',
                        link: '/exams/sat/fees'
                    },
                    {
                        name: 'SAT Eligibility',
                        link: '/exams/sat/eligibility'
                    },
                    {
                        name: 'SAT Dates',
                        link: '/exams/sat/dates'
                    },
                    {
                        name: 'SAT Registration',
                        link: '/exams/sat/registration'
                    },
                    {
                        name: 'SAT Centres',
                        link: '/exams/sat/centre'
                    },
                    {
                        name: 'SAT Results',
                        link: '/exams/sat/results'
                    },
                    {
                        name: 'SAT Preparation',
                        link: '/exams/sat/preparation'
                    },
                    {
                        name: 'SAT Practice Test',
                        link: '/exams/sat/practice-test'
                    },
                    {
                        name: 'SAT Blogs',
                        link: '/blog/category/sat/'
                    }
                ]
            }
        ]
    },
    pte: {
        uniqueId: 'pte',
        tabName: 'PTE',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'PTE Overview',
                        link: '/exams/pte'
                    },
                    {
                        name: 'PTE Syllabus',
                        link: '/exams/pte/syllabus'
                    },
                    {
                        name: 'PTE Exam Fees',
                        link: '/exams/pte/fees'
                    },
                    {
                        name: 'PTE Dates',
                        link: '/exams/pte/dates'
                    },
                    {
                        name: 'PTE Registration',
                        link: '/exams/pte/registration'
                    },
                    {
                        name: 'PTE Centres',
                        link: '/exams/pte/centre'
                    },
                    {
                        name: 'PTE Results',
                        link: '/exams/pte/results'
                    },
                    {
                        name: 'PTE Slot Booking',
                        link: '/exams/pte/slot-booking'
                    },
                    {
                        name: 'PTE Preparation',
                        link: '/exams/pte/preparation'
                    }
                ]
            },
            {
                heading: 'Practice',
                navLinks: [
                    {
                        name: 'PTE Test',
                        link: '/exams/pte/practice-test',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg'
                    },
                    {
                        name: 'Listening',
                        link: '/exams/pte/practice-test/listening',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg'
                    },
                    {
                        name: 'Reading',
                        link: '/exams/pte/practice-test/reading',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg'
                    },
                    {
                        name: 'Speaking & Writing',
                        link: '/exams/pte/practice-test/speaking-writing',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg'
                    }
                ]
            }
        ]
    },
    toefl: {
        uniqueId: 'toefl',
        tabName: 'TOEFL',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'TOEFL Overview',
                        link: '/exams/toefl'
                    },
                    {
                        name: 'TOEFL Syllabus',
                        link: '/exams/toefl/syllabus'
                    },
                    {
                        name: 'TOEFL Fees',
                        link: '/exams/toefl/fees'
                    },
                    {
                        name: 'TOEFL Dates',
                        link: '/exams/toefl/dates'
                    },
                    {
                        name: 'TOEFL Registration',
                        link: '/exams/toefl/registration'
                    },
                    {
                        name: 'TOEFL Results',
                        link: '/exams/toefl/results'
                    },
                    {
                        name: 'TOEFL Preparation',
                        link: '/exams/toefl/preparation'
                    }
                ]
            },
            {
                heading: 'Practice',
                navLinks: [
                    {
                        name: 'TOEFL Test',
                        link: '/exams/toefl/practice-test',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/speed_icon_xUV6R9Ivu.svg'
                    },
                    {
                        name: 'Speaking',
                        link: '/exams/toefl/practice-test/speaking',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/chat_icon_QlTt4yG6WW.svg'
                    },
                    {
                        name: 'Writing',
                        link: '/exams/toefl/practice-test/writing',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/note_icon_LBq7a_bks.svg'
                    },
                    {
                        name: 'Reading',
                        link: '/exams/toefl/practice-test/reading',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/book_icon_1_wnYXOu1ElV.svg'
                    },
                    {
                        name: 'Listening',
                        link: '/exams/toefl/practice-test/listening',
                        icon: 'https://ik.imagekit.io/onsnhxjshmp/leapscholar_header/headphone_icon_g243t3cUQ4.svg'
                    }
                ]
            }
        ]
    },
    gre: {
        uniqueId: 'gre',
        tabName: 'GRE',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'GRE Overview',
                        link: '/exams/gre'
                    },
                    {
                        name: 'GRE Syllabus',
                        link: '/exams/gre/syllabus'
                    },
                    {
                        name: 'GRE Exam Fees',
                        link: '/exams/gre/fees'
                    },
                    {
                        name: 'GRE Dates',
                        link: '/exams/gre/dates'
                    },
                    {
                        name: 'GRE Registration',
                        link: '/exams/gre/registration'
                    },
                    {
                        name: 'GRE Results',
                        link: '/exams/gre/results'
                    },
                    {
                        name: 'GRE Slot Booking',
                        link: '/exams/gre/slot-booking'
                    },
                    {
                        name: 'GRE Preparation',
                        link: '/exams/gre/preparation'
                    },
                    {
                        name: 'GRE Practice test',
                        link: '/exams/gre/practice-test'
                    }
                ]
            }
        ]
    },
    gmat: {
        uniqueId: 'gmat',
        tabName: 'GMAT',
        topHeading: null,
        topHeadingLink: null,
        subNavs: [
            {
                heading: 'Exam details',
                navLinks: [
                    {
                        name: 'GMAT Overview',
                        link: '/exams/gmat'
                    },
                    {
                        name: 'GMAT Syllabus',
                        link: '/exams/gmat/syllabus'
                    },
                    {
                        name: 'GMAT Exam Fees',
                        link: '/exams/gmat/fees'
                    },
                    {
                        name: 'GMAT Dates',
                        link: '/exams/gmat/dates'
                    },
                    {
                        name: 'GMAT Registration',
                        link: '/exams/gmat/registration'
                    },
                    {
                        name: 'GMAT Results',
                        link: '/exams/gmat/results'
                    },
                    {
                        name: 'GMAT Preparation',
                        link: '/exams/gmat/preparation'
                    },
                    {
                        name: 'GMAT Sample papers',
                        link: '/exams/gmat/sample-paper'
                    }
                ]
            }
        ]
    }
};
export var resourcesNavData = {
    uniqueId: 'resources',
    tabName: 'Resources',
    topHeading: null,
    topHeadingLink: null,
    subNavs: [
        {
            heading: 'Books',
            navLinks: [
                {
                    name: 'IELTS Books',
                    link: '/exams/ielts/books'
                },
                {
                    name: 'SAT Books',
                    link: '/exams/sat/books'
                },
                {
                    name: 'PTE Books',
                    link: '/exams/pte/books'
                },
                {
                    name: 'TOEFL Books',
                    link: '/exams/toefl/books'
                },
                {
                    name: 'GRE Books',
                    link: '/exams/gre/books'
                },
                { name: 'GMAT Books', link: '/exams/gmat/books' }
            ]
        },
        {
            heading: 'LOR',
            navLinks: [
                {
                    name: 'LOR Blog',
                    link: '/blog/letter-of-recommendation/'
                },
                {
                    name: 'LOR for Masters',
                    link: '/blog/lor-letter-of-recommendation-for-masters-sample-format/'
                },
                {
                    name: 'LOR for PhD',
                    link: '/blog/letter-of-recommendation-for-phd-sample-examples-and-pdf/'
                }
            ]
        },
        {
            heading: 'SOP',
            navLinks: [
                {
                    name: 'SOP Blog',
                    link: '/blog/sop-meaning-and-format/'
                },
                {
                    name: 'SOP for Masters',
                    link: '/blog/sop-statement-of-purpose-for-masters-samples/'
                },
                {
                    name: 'SOP for MBA',
                    link: '/blog/statement-of-purpose-for-mba-with-sample/'
                },
                {
                    name: 'SOP for PhD',
                    link: '/blog/sop-statement-of-purpose-for-phd-and-sample/'
                }
            ]
        },
        {
            heading: 'Other',
            navLinks: [
                {
                    name: 'Counsellors',
                    link: '/counsellors'
                }
            ]
        }
    ]
};
//# sourceMappingURL=constant.js.map